
const baseUrl = '/dashboard';

const links = {

   _link(base, _id) {
      let link =`${baseUrl}/${base}`;
      if (_id)
         link += `/${_id}`;
      return link;
   },

   agent(_id) {
      return this._link('agents', _id);
   },

   cashRequisition(_id) {
      return this._link('cash-requisitions', _id);
   },

   customer(_id) {
      return this._link('customers', _id);
   },

   delivery(_id) {
      return this._link('deliveries', _id);
   },

   installation(_id) {
      return this._link('installations', _id);
   },

   loan(_id) {
      return this._link('loans', _id);
   },
   
   loanPayment(_id) {
      return this._link('loan-payments', _id);
   },

   token(_id) {
      return this._link('tokens', _id);
   },

}

export default links;